import Vue from 'vue'

function currencyFilter (input, options) {
  const number = Number(input)
  
  if (Number.isNaN(number)) {
    console.error(`${input} is not a valid number.`)
    return input
  }
  
  const navigatorLanguage = window.navigator.language
  options = Object.assign({ style: 'currency' }, options)
  
  return new Intl.NumberFormat(navigatorLanguage, options).format(number)
}

export default Vue.filter('currency', currencyFilter)
